export default __webpack_public_path__ + "static/media/amicis-spread-spicy-peper-chicken-arugula-and-spinach-salad.881c5c49.jpg";